import { InfoOutlineIcon } from '@carboncopyco/icons';
import { TextCaption, Tooltip } from '@carboncopyco/ui';
import { useRef } from 'react';

type TableInfoTooltipProps = {
  label: string;
};

export const TableInfoIcon = ({ label }: TableInfoTooltipProps) => {
  const infoIconRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={infoIconRef}>
        <InfoOutlineIcon size={12} />
      </div>
      <Tooltip
        delay={[300, 0]}
        interactive={false}
        noArrow
        placement="right-start"
        anchorRef={infoIconRef}
        zIndex={9999}
      >
        <div className="p-3 bg-ds-accent3-100 rounded-md w-48 flex whitespace-normal">
          <TextCaption label={label} />
        </div>
      </Tooltip>
    </>
  );
};
